// extracted by mini-css-extract-plugin
export default {"sliderWrapper":"styles_sliderWrapper__awQ5a","thumb":"styles_thumb__0yPZT","value":"styles_value__s0pRe","sliderHolder":"styles_sliderHolder__tjEk1"};